import { Box, Button, TextField, styled } from "@mui/material";
import { Link } from "react-router-dom";
import { colors, heroGradient } from "../../theme/colors";

export const LoginPage = styled(Box)({
  display: "flex",
  minHeight: "100vh",
  width: "100%",
  overflow: "hidden",
  backgroundColor: colors.white,
});

export const LeftPanel = styled(Box)({
  flex: "0 0 42%",
  minWidth: "360px",
  maxWidth: "560px",
  display: "flex",
  flexDirection: "column",
  backgroundColor: colors.white,
  position: "relative",
  zIndex: 2,

  "@media (max-width: 960px)": {
    flex: "1 1 100%",
    maxWidth: "100%",
    minWidth: "unset",
  },
});

export const LogoBar = styled(Box)({
  padding: "40px 48px 0",
  display: "flex",
  alignItems: "center",
  gap: "10px",

  "& .login-logo": {
    height: "43px",
    width: "auto",
    display: "block",
  },

  "@media (max-width: 600px)": {
    padding: "28px 24px 0",
  },
});

export const FormSection = styled(Box)({
  flex: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "48px",

  "@media (max-width: 600px)": {
    padding: "32px 24px 48px",
  },
});

export const FormInner = styled(Box)({
  width: "100%",
  maxWidth: "380px",
});

export const WelcomeTitle = styled("h1")({
  margin: "0 0 32px",
  fontSize: "28px",
  fontWeight: 700,
  lineHeight: 1.2,
  color: colors.text.primary,
  fontFamily: '"Inter", "Helvetica Neue", Arial, sans-serif',
});

export const LoginTextField = styled(TextField)({
  marginBottom: "16px",
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    backgroundColor: colors.white,
    fontSize: "15px",
    transition: "all 0.2s ease",
    "& fieldset": {
      borderColor: "#d1d5db",
    },
    "&:hover fieldset": {
      borderColor: colors.primary,
    },
    "&.Mui-focused fieldset": {
      borderColor: colors.primary,
      borderWidth: "1.5px",
    },
    "&:hover": {
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
    },
    "&.Mui-focused": {
      boxShadow: "0 4px 20px rgba(127, 29, 29, 0.08)",
    },
    "& input:-webkit-autofill": {
      WebkitBoxShadow: `0 0 0 1000px ${colors.primaryLight} inset`,
      WebkitTextFillColor: colors.text.primary,
      caretColor: colors.text.primary,
      transition: "background-color 5000s ease-in-out 0s",
    },
    "& input:-webkit-autofill:hover": {
      WebkitBoxShadow: `0 0 0 1000px ${colors.primaryLight} inset`,
    },
    "& input:-webkit-autofill:focus": {
      WebkitBoxShadow: `0 0 0 1000px ${colors.primaryLight} inset`,
    },
  },
  "& .MuiInputLabel-root": {
    color: "#6b7280",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: colors.primary,
  },
});

export const SignInButton = styled(Button)({
  marginTop: "8px",
  height: "48px",
  borderRadius: "8px !important",
  backgroundColor: `${colors.primary} !important`,
  color: `${colors.white} !important`,
  fontSize: "15px !important",
  fontWeight: 600,
  textTransform: "none",
  boxShadow: "none !important",
  "&:hover": {
    backgroundColor: `${colors.primaryHover} !important`,
    boxShadow: "0 8px 20px rgba(127, 29, 29, 0.22) !important",
    transform: "translateY(-1px)",
  },
  "&:active": {
    transform: "translateY(0px)",
  },
  transition: "all 0.2s ease !important",
});

export const ForgotLink = styled(Link)({
  display: "inline-block",
  marginTop: "16px",
  color: "#6b7280",
  fontSize: "14px",
  fontWeight: 500,
  textDecoration: "none",
  "&:hover": {
    color: colors.primary,
    textDecoration: "none",
  },
  transition: "color 0.2s ease",
});

export const RightPanel = styled(Box)({
  flex: "1 1 58%",
  position: "relative",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  minHeight: "100vh",
  height: "100vh",
  background: heroGradient,

  "@media (max-width: 960px)": {
    display: "none",
  },
});

export const HeroContent = styled(Box)({
  position: "relative",
  zIndex: 1,
  flex: 1,
  height: "100%",
  display: "flex",
  flexDirection: "column",
  padding: "56px 0 0 56px",
  overflow: "hidden",
});

export const HeroHeadline = styled("h2")({
  margin: 0,
  maxWidth: "560px",
  paddingRight: "48px",
  flexShrink: 0,
  fontSize: "clamp(32px, 3.5vw, 44px)",
  fontWeight: 700,
  lineHeight: 1.22,
  letterSpacing: "-0.025em",
  color: colors.white,
  fontFamily: '"Inter", "Helvetica Neue", Arial, sans-serif',
});

export const HeroImageWrap = styled(Box)({
  flex: 1,
  display: "flex",
  alignItems: "flex-end",
  marginTop: "32px",
  minHeight: 0,
  width: "100%",
  overflow: "hidden",

  "& img": {
    display: "block",
    width: "100%",
    maxWidth: "100%",
    height: "auto",
    maxHeight: "100%",
    objectFit: "contain",
    objectPosition: "left bottom",
    borderRadius: "12px 12px 0 0",
    boxShadow: "0 24px 80px rgba(0, 0, 0, 0.35)",
    pointerEvents: "none",
    userSelect: "none",
  },
});
